import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { fetchTicketSummary } from 'Pages/TicketPage/Redux/thunks';
import TicketPage from 'Pages/TicketPage/TicketPage';

import { 
  getIsFetching, 
  getIsFetchFailed,
  getTicketSummary, 
  getIsTicketNotFound,
} from 'Pages/TicketPage/Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  isTicketNotFound: boolean;
  ticketSummary: Julius.Website.TicketSummaryViewModel;
  fetchTicketSummary: (orderID: number, barcode: string) => void;
}

type Props = IPropsInternal & RouteComponentProps<{ orderID: number, barcode: string }>;

class TicketPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    const { orderID, barcode } = this.props.match.params;
    this.props.fetchTicketSummary(orderID, barcode);
  }

  render() {

    return (
      <TicketPage
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        isTicketNotFound={ this.props.isTicketNotFound }
        ticketSummary={ this.props.ticketSummary }
        orderID={ Number(this.props.match.params.orderID) }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    isFetchFailed: getIsFetchFailed(state),
    isTicketNotFound: getIsTicketNotFound(state),
    ticketSummary: getTicketSummary(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchTicketSummary,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(TicketPageContainer);


// WEBPACK FOOTER //
// ./src/pages/TicketPage/TicketPageContainer.tsx